import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { embryologyInitialData } from "Components/Pages/EmbryologyDataSheet/Constant";
import { toast } from "react-toastify";

export const initialPatientDetailsEDS = {
  eggs: null,
  eggs_by: [],
  eggs_by_ivf_id: [],
  eggs_to_ivf_id: [],
  eggs_to: [],
  ivf_flow_id: "",
  eggs_donor: null,
  eggs_by_donor: [],
  eggs_by_ivf_id_donor: [],
  eggs_to_donor: [],
};

const initialState = {
  embryologyData: {},
  embryologyDataLoading: false,
  embryologyDataUpdate: false,
  patientList: [],
  eggsToSpermByPatientList: [],
  embryologyRedirect: false,
  ivfIdRedirect: "",
  eggsToPatientList: [],
  embryologyDetails: embryologyInitialData,
  embryology_count: [],
  eggsToBackupList: [],
  eggsToDonorBackupList: [],
  eggsByBackupList: [],
  eggsByIvfOptionTemp: [],
  eggsToIvfOptionTemp: [],
  backupIvfList: [],
  backupEggsToIvfList: [],
  ivfIdOption: [],
  eggsByDonorBackupList: [],
  isSearchPatient: false,
  eggsByIvfDonorOptionTemp: [],
  backupIvfDonerList: [],
  spermBySearch: [],
  spermByDonorSearch: [],
  doctorList: [],
  patientDetailsEDS: initialPatientDetailsEDS,
  partnerDetailsEDS: {
    sperms: null,
    sperms_by: null,
    sperms_quality: null,
    sperms_quality_other: null,
    sperms_prep_method: null,
    sperms_prep_method_other: null,
    frozen_vial_id: null,
    sperms_donor: null,
    sperms_by_donor: null,
    sperms_quality_donor: null,
    sperms_quality_other_donor: null,
    sperms_prep_method_donor: null,
    sperms_prep_method_other_donor: null,
    frozen_vial_id_donor: null,
  },
};

export const createEmbryologyData = createAsyncThunk(
  "add-embryology-data",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { location_id, patient_reg_id, module_id, payload } = props;
      axios
        .post(
          `embryology/add-detail/${location_id}/${patient_reg_id}/${module_id}`,
          payload
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            toast.success(res.data?.msg);
            resolve(res.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getEmbryologyData = createAsyncThunk(
  "get-embryology-data",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { location_id, patient_reg_id, module_id, ivf_flow_id } = props;
      axios
        .get(
          `embryology/view/${location_id}/${patient_reg_id}/${module_id}/${ivf_flow_id}`
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            if (Object.keys(res?.data?.data).length > 0) {
              resolve(res.data?.data);
            } else {
              resolve({});
            }
          } else {
            reject({});
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const printEmbryologyFlowSheet = createAsyncThunk(
  "embryology-data-print",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { moduleId, patientRegId, ivfFlowId, location_id } = props;
      axios
        .post(
          `/embryology/print/${location_id}/${moduleId}/${patientRegId}/${ivfFlowId}`
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            window.open(res.data.data.url, "_blank");
            resolve(res.data.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const printEmbryoWarming = createAsyncThunk(
  "embryology-warming-data-print",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { moduleId, patientRegId, ivfFlowId, location_id } = props;
      axios
        .post(
          `/embryo-warming/print/${location_id}/${moduleId}/${patientRegId}/${ivfFlowId}`
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            window.open(res.data.data.url, "_blank");
            resolve(res.data.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const printVitrificationReport = createAsyncThunk(
  "print-vitrification-report",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { moduleId, patientRegId, ivfFlowId, payload, location_id } = props;
      axios
        .post(
          `vitrification-report/print/${location_id}/${moduleId}/${patientRegId}/${ivfFlowId}`,
          payload
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            window.open(res.data.data.url, "_blank");
            resolve(res.data.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const printBlankPdfEmbryoTransfer = createAsyncThunk(
  "print-blank-embryology-details",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { moduleId, location_id, patientRegId, ivfFlowId } = props;
      axios
        .post(
          `/embryology/print/blank/${location_id}/${moduleId}/${ivfFlowId}/${patientRegId}`
        )
        .then((res) => {
          if (res?.data?.err === 0) {
            window.open(res.data.data.url, "_blank");
            resolve(res.data.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const editEmbryologyData = createAsyncThunk(
  "luteal-embryology-data",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      const { location_id, _id, module_id, payload } = props;
      axios
        .patch(`embryology/update/${location_id}/${_id}/${module_id}`, payload)
        .then((res) => {
          if (res?.data?.err === 0) {
            toast.success(res.data?.msg);
            resolve(res.data);
          } else {
            toast.error(res?.data?.msg);
            reject({ message: res?.data?.msg });
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getPatientSearch = createAsyncThunk(
  "get-global-search-data",
  (props, { dispatch }) => {
    return new Promise((resolve, reject) => {
      axios
        .post("patient-registration/search", props)
        .then((res) => {
          if (res?.data?.err === 0) {
            if (Object.keys(res?.data?.data).length > 0) {
              resolve(res?.data?.data);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);
export const getPatientList = createAsyncThunk(
  "get-global-list-data",
  (props, { dispatch }) => {
    const { start, limit, patient_name, patient_reg_id } = props;

    return new Promise((resolve, reject) => {
      axios
        .post(`eggs-by-patient/list/${start}/${limit}`, {
          patient_name: patient_name,
          patient_reg_id: patient_reg_id || null,
        })
        .then((res) => {
          if (res?.data?.err === 0) {
            if (res?.data?.data?.patient_list?.length > 0) {
              dispatch(setPatientListData(res?.data?.data?.patient_list));
              resolve(res?.data?.data?.patient_list);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getEggsToSpermByPatientList = createAsyncThunk(
  "embryology/eggs-to-sperm-by-patient",
  (props, { dispatch }) => {
    const { start, limit, patient_name, patient_reg_id, key_name } = props;

    return new Promise((resolve, reject) => {
      axios
        .post(`embryology/eggs-to-sperm-by-patient/list/${start}/${limit}`, {
          patient_name: patient_name,
          patient_reg_id: patient_reg_id || null,
        })
        .then((res) => {
          if (res?.data?.err === 0) {
            if (res?.data?.data?.patient_list?.length > 0) {
              // dispatch(
              //   setEggsToSpermByPatientList(res?.data?.data?.patient_list)
              // );
              if (key_name === "eggs_to") {
                dispatch(setEggsToPatientList(res?.data?.data?.patient_list));
              } else if (key_name === "eggs_to_donor") {
                dispatch(
                  setEggsToDonorPatientList(res?.data?.data?.patient_list)
                );
              } else if (key_name === "sperms_by") {
                dispatch(setSpermByPatientList(res?.data?.data?.patient_list));
              } else if (key_name === "sperms_by_donor") {
                dispatch(
                  setSpermByDonorPatientList(res?.data?.data?.patient_list)
                );
              }
              resolve(res?.data?.data?.patient_list);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const getEggsToPatientList = createAsyncThunk(
  "get-global-list-data",
  (payload, { dispatch }) => {
    const { start, limit, patient_name } = payload;

    return new Promise((resolve, reject) => {
      axios
        .post(`embryology/eggs-to-sperm-patient/list/${start}/${limit}`, {
          patient_name: patient_name,
        })
        .then((res) => {
          if (res?.data?.err === 0) {
            if (Object.keys(res?.data?.data?.patient_list).length > 0) {
              resolve(res?.data?.data?.patient_list);
            } else {
              resolve([]);
            }
          } else {
            reject([]);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.msg);
          reject(error);
        });
    });
  }
);

export const embryologyDataSlice = createSlice({
  name: "embryology-Data",
  initialState,
  reducers: {
    setEmbryologyDataUpdate: (state, action) => {
      state.embryologyDataUpdate = action.payload;
    },
    setEmbryologyData: (state, action) => {
      state.embryologyData = action.payload;
    },
    setPatientListData: (state, action) => {
      state.patientList = action.payload;
    },
    setEggsToSpermByPatientList: (state, action) => {
      state.eggsToSpermByPatientList = action.payload;
    },
    setEggsToPatientList: (state, action) => {
      state.eggsToPatientList = action.payload;
    },
    setEggsToDonorPatientList: (state, action) => {
      state.eggsToDonorPatientList = action.payload;
    },
    setSpermByPatientList: (state, action) => {
      state.spermByPatientList = action.payload;
    },
    setSpermByDonorPatientList: (state, action) => {
      state.spermByDonorPatientList = action.payload;
    },
    setEmbryologyRedirect: (state, action) => {
      state.embryologyRedirect = action.payload;
    },
    setIvfIdRedirect: (state, action) => {
      state.ivfIdRedirect = action.payload;
    },
    setPatientDetailsEDS: (state, action) => {
      state.patientDetailsEDS = action.payload;
    },
    setPartnerDetailsEDS: (state, action) => {
      state.partnerDetailsEDS = action.payload;
    },
    setEmbryologyDetails: (state, action) => {
      state.embryologyDetails = action.payload;
    },
    setEmbryology_count: (state, action) => {
      state.embryology_count = action.payload;
    },
    setEggsToDonorBackupList: (state, action) => {
      state.eggsToDonorBackupList = action.payload;
    },
    setEggsToBackupList: (state, action) => {
      state.eggsToBackupList = action.payload;
    },
    setEggsByBackupList: (state, action) => {
      state.eggsByBackupList = action.payload;
    },
    setEggsByIvfOptionTemp: (state, action) => {
      state.eggsByIvfOptionTemp = action.payload;
    },
    setEggsToIvfOptionTemp: (state, action) => {
      state.eggsToIvfOptionTemp = action.payload;
    },
    setBackupIvfList: (state, action) => {
      state.backupIvfList = action.payload;
    },
    setBackupEggsToIvfList: (state, action) => {
      state.backupEggsToIvfList = action.payload;
    },
    setIvfIdOption: (state, action) => {
      state.ivfIdOption = action.payload;
    },
    setEggsByDonorBackupList: (state, action) => {
      state.eggsByDonorBackupList = action.payload;
    },
    setIsSearchPatient: (state, action) => {
      state.isSearchPatient = action.payload;
    },
    setEggsByIvfDonorOptionTemp: (state, action) => {
      state.eggsByIvfDonorOptionTemp = action.payload;
    },
    setBackupIvfDonerList: (state, action) => {
      state.backupIvfDonerList = action.payload;
    },
    setSpermBySearch: (state, action) => {
      state.spermBySearch = action.payload;
    },
    setSpermByDonorSearch: (state, action) => {
      state.spermByDonorSearch = action.payload;
    },
    setDoctorList: (state, action) => {
      state.doctorList = action.payload;
    },
  },
  extraReducers: {
    [createEmbryologyData.pending]: (state) => {
      state.embryologyDataUpdate = false;
      state.embryologyDataLoading = true;
    },
    [createEmbryologyData.rejected]: (state) => {
      state.embryologyDataUpdate = false;
      state.embryologyDataLoading = false;
    },
    [createEmbryologyData.fulfilled]: (state) => {
      state.embryologyDataUpdate = true;
      state.embryologyDataLoading = false;
    },
    [getEmbryologyData.pending]: (state) => {
      state.embryologyData = {};
      state.embryologyDataLoading = true;
    },
    [getEmbryologyData.rejected]: (state) => {
      state.embryologyData = {};
      state.embryologyDataLoading = false;
    },
    [getEmbryologyData.fulfilled]: (state, action) => {
      state.embryologyData = action.payload;
      state.embryologyDataLoading = false;
    },
    [editEmbryologyData.pending]: (state) => {
      state.embryologyDataLoading = true;
      state.embryologyDataUpdate = false;
    },
    [editEmbryologyData.rejected]: (state) => {
      state.embryologyDataLoading = false;
      state.embryologyDataUpdate = false;
    },
    [editEmbryologyData.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
      state.embryologyDataUpdate = true;
    },

    [printEmbryologyFlowSheet.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [printEmbryologyFlowSheet.rejected]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printEmbryologyFlowSheet.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
    },

    [printEmbryoWarming.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [printEmbryoWarming.rejected]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printEmbryoWarming.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printVitrificationReport.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [printVitrificationReport.rejected]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printVitrificationReport.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printBlankPdfEmbryoTransfer.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [printBlankPdfEmbryoTransfer.rejected]: (state) => {
      state.embryologyDataLoading = false;
    },
    [printBlankPdfEmbryoTransfer.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
    },
    [getPatientSearch.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [getPatientSearch.rejected]: (state) => {
      state.patientList = [];
      state.embryologyDataLoading = false;
    },
    [getPatientSearch.fulfilled]: (state, action) => {
      state.embryologyDataLoading = false;
      state.patientList = action.payload;
    },
    [getPatientList.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [getPatientList.rejected]: (state) => {
      state.patientList = [];
      state.embryologyDataLoading = false;
    },
    [getPatientList.fulfilled]: (state) => {
      state.embryologyDataLoading = false;
    },
    [getEggsToPatientList.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [getEggsToSpermByPatientList.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [getEggsToSpermByPatientList.rejected]: (state) => {
      state.eggsToSpermByPatientList = [];
      state.embryologyDataLoading = false;
    },
    [getEggsToSpermByPatientList.fulfilled]: (state, action) => {
      state.embryologyDataLoading = false;
      state.eggsToSpermByPatientList = action.payload;
    },
    [getEggsToPatientList.pending]: (state) => {
      state.embryologyDataLoading = true;
    },
    [getEggsToPatientList.rejected]: (state) => {
      state.eggsToPatientList = [];
      state.embryologyDataLoading = false;
    },
    [getEggsToPatientList.fulfilled]: (state, action) => {
      state.embryologyDataLoading = false;
      state.eggsToPatientList = action.payload;
    },
  },
});
export const {
  setEmbryologyDataUpdate,
  setEmbryologyData,
  setPatientListData,
  setEggsToSpermByPatientList,
  setEggsToPatientList,
  setEggsToDonorPatientList,
  setSpermByPatientList,
  setSpermByDonorPatientList,
  setEmbryologyRedirect,
  setIvfIdRedirect,
  setPatientDetailsEDS,
  setPartnerDetailsEDS,
  setEmbryologyDetails,
  setEmbryology_count,
  setEggsToBackupList,
  setEggsToDonorBackupList,
  setEggsByBackupList,
  setEggsByIvfOptionTemp,
  setEggsToIvfOptionTemp,
  setBackupIvfList,
  setBackupEggsToIvfList,
  setIvfIdOption,
  setEggsByDonorBackupList,
  setIsSearchPatient,
  setEggsByIvfDonorOptionTemp,
  setBackupIvfDonerList,
  setSpermBySearch,
  setSpermByDonorSearch,
  setDoctorList,
} = embryologyDataSlice.actions;
export default embryologyDataSlice.reducer;
